import React from 'react';
import { motion } from 'framer-motion';
interface PaymentMethodTileProps {
  id: string;
  name: string;
  logo: string; // Using text/emoji for simplicity in this demo, usually an image
  selected: boolean;
  onSelect: () => void;
}
export function PaymentMethodTile({
  id,
  name,
  logo,
  selected,
  onSelect
}: PaymentMethodTileProps) {
  return <motion.button whileTap={{
    scale: 0.95
  }} onClick={onSelect} className={`flex flex-col items-center justify-center p-4 rounded-xl border-2 aspect-square transition-all ${selected ? 'border-[#006a4e] bg-[#006a4e]/5' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-58">
      <div className="text-3xl mb-2" data-id="element-59">{logo}</div>
      <span className="text-sm font-bold text-gray-700 font-bengali" data-id="element-60">
        {name}
      </span>
    </motion.button>;
}